export const ENDPOINTS = {
    WORKSPACE_STATUSES: '/workspaces/:workspaceId/statuses',
    TAGS: '/external-dashboard/workspaces/:workspaceId/tags',
    PLUGIN_RUN: '/external-dashboard/workspaces/:workspaceId/plugins/run',
    WEBHOOK: '/external-dashboard/workspaces/:workspaceId/webhook',
    WEBHOOK_TEST: '/external-dashboard/workspaces/:workspaceId/workflows/definitions/:workflowId/webhook',
    WEBHOOK_ACTIVITY_LOG: '/external-dashboard/workspaces/:workspaceId/webhook/activity/:taskId',
    LINK: '/external-dashboard/workspaces/:workspaceId/link',
    INCIDENTS: '/external-dashboard/workspaces/:workspaceId/incidents',
    INCIDENT_DETAILS: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId',
    INCIDENT_RECORD_INFORMATION: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/record-information',
    INCIDENT_OPEN: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/open',
    INCIDENT_PENDING: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/mark-pending',
    INCIDENT_IN_PROGRESS: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/mark-in-progress',
    INCIDENT_CLOSE: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/close',
    INCIDENT_COMMENTS: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/comments',
    INCIDENTS_ASSIGNMENTS: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/assignments',
    INCIDENT_ASSIGNMENTS_DETAILS: '/external-dashboard/workspaces/:workspaceId/incidents/:incidentId/assignments/:assignmentId',
    INCIDENTS_STATS: '/external-dashboard/workspaces/:workspaceId/incidents/stats',
    INCIDENTS_CHARTS_SEVERITY: '/external-dashboard/workspaces/:workspaceId/incidents/charts/severity',
    INCIDENTS_CHARTS_AVG_REVIEW_TIME: '/external-dashboard/workspaces/:workspaceId/incidents/charts/review-time',
    INCIDENTS_RECORDS: '/external-dashboard/workspaces/:workspaceId/incidents/records/:recordId',
    UPLOAD_DISPLAY_DOCUMENT_RESOURCE: '/external-dashboard/workspaces/:workspaceId/workflows/definitions/tasks/fill-document/extract-fields',
    SEND_GRID_TEMPLATES: '/editor/sendgrid/config/templates',
    INSIGHTS: '/external-dashboard/workspaces/:workspaceId/insights/',
    INSIGHTS_DETAILS: '/external-dashboard/workspaces/:workspaceId/insights/:insightId',
    INSIGHTS_AVAILABLE_STEPS: '/external-dashboard/workspaces/:workspaceId/insights/available-steps/',
    INSIGHTS_METRICS: '/external-dashboard/workspaces/:workspaceId/insights/:insightId/metrics',
    CUSTOM_TABLES_LIST: '/external-dashboard/workspaces/:workspaceId/meta/tables',
    WIDGET_TOKEN: '/external-dashboard/workspaces/:workspaceId/token',
}

export const DASHBOARD_ENDPOINTS = {
    RESOURCE: '/external-dashboard/workspaces/:workspaceId/resources/:resourceId',
    WORKFLOW_PARAMETERS: '/external-dashboard/workspaces/:workspaceId/parameters',
    WORKFLOW_PARAMETERS_ID: '/parameters/:parametersId',
    SECRET: '/workspaces/:workspaceId/secret',
    DATA_MODELS: '/workspaces/:workspaceId/data-models',
    CUSTOM_TABLES: '/external-dashboard/workspaces/:workspaceId/meta/tables',
    CUSTOM_TABLES_IMPORT: '/external-dashboard/workspaces/:workspaceId/meta/tables/import',
    CUSTOM_TABLES_TABLE: '/external-dashboard/workspaces/:workspaceId/meta/tables/:tableId',
    CUSTOM_TABLES_TABLE_RECORD_LABEL: '/external-dashboard/workspaces/:workspaceId/meta/tables/:tableId/record-label',
    CUSTOM_TABLES_TABLE_FIELD: '/external-dashboard/workspaces/:workspaceId/meta/tables/:tableId/fields',
    CUSTOM_TABLES_TABLE_FIELD_ID: '/external-dashboard/workspaces/:workspaceId/meta/tables/:tableId/fields/:fieldId',
    CUSTOM_TABLES_RELATIONS: '/external-dashboard/workspaces/:workspaceId/meta/relations',
    CUSTOM_TABLES_RELATION_DETAILS: '/external-dashboard/workspaces/:workspaceId/meta/relations/:relationId',
}
